<template><div><h1 id="zusagen-anzahl-korrigieren" tabindex="-1"><a class="header-anchor" href="#zusagen-anzahl-korrigieren"><span>Zusagen-Anzahl korrigieren</span></a></h1>
<p>Zusagen-Anzahl korrigieren — Aktualisiert die Zusagen-Anzahl</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Das Programm aktualisiert die Anzahl in den Tabellen Zusagen, Regionen und Akquisitionen.</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>System → Datenpflege → Zusagen-Anzahl korrigieren</p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p>Der Job benötigt keine Parameter</p>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Der Job erzeugt kein Output.</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Zusagen, Regionen und Akquisitionen</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Die Anzahl in den Tabellen Zusagen, Regionen und Akquisitionen.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


